import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import * as constants from '../constants/all';
import * as loginActions from '../actions/login';
import * as profileActions from '../actions/profile';
import * as coreActions from '../actions/core';
import * as enrollmentActions from '../constants/enrollment';
import * as Action from '../actions/enrollment';
import { Log } from 'ng2-logger';
import { LoginPageService } from '../../api/login-page-service';
import { Common } from '../../core/common';
import { ILoginInformation, ILoginFormSagaModel, ILoginResultData } from '../../models/pages/login';
import { ILoginAnnouncementModel } from '../../models/pages/announcement';
import { LoginService } from '../../api/login-service';
import { IAuthInformation, IAction } from '../../models/action/core';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import { param } from 'jquery';
import { UserType } from '../../models/enums/userType';
import { setTitleAndLogos } from '../../utils';
import { SetTwoFactorMethodError, SetVerificateUserMail } from '../actions/login';
const T = Translator.create();
const _logger = Log.create('Login Sagas');


function* setLoginPageData(params: any): any {
    const loginPageService = new LoginPageService();
    const common = new Common();
    try {
        const pageData = yield loginPageService.GetLoginInformation().then((responseData: Response) => {
            if (responseData.status !== 200) {
                throw (responseData.status);
            } else {
                return responseData.json();
            }
        }).then((data: ILoginInformation | null) => {
            if (!data) {
                throw new Error('Data is null');
            } else {
                return data;
            }
        });
        yield put(loginActions.setPageData(pageData));
        common.InsertOrganizationInfosToLocalStorage({ OrganizationAbbreviation: pageData.abbreviation, OrganizationLogo: pageData.organizationLogo, GoogleAnalyticsCode: pageData.googleAnalyticsCode })
        setTitleAndLogos();
        if (params.callback) {
            params.callback();
        }
    } catch (error: any) {
        if (/^\d+/.test(error)) {
            yield put(coreActions.newNotification(T.t('r_error_loading_page') + ' ' + T.t('r_error_code') + error, '', '', 'topRight', 'error'));
        } else {
            yield put(coreActions.newNotification(T.t('r_cant_load_page') + ' ' + T.t('r_problem_internet_connection') + error, '', '', 'topRight', 'error'));
        }
    }
}

// function* getEnrollment() {
//     const enrollmentData = yield put({ type: enrollmentActions.actions.ENROLLMENT_GETDATA });
//     return enrollmentData;
// }

function* loginToAlms(params: any): any {
    let isError = false;
    let errorList: any;
    const _loginService = new LoginService();
    const _common = new Common();
    const requestReturn = yield _loginService.ConnectToAlms(params.parameters ? params.parameters : null)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        })
        .then(response => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

    if (isError) {
        yield put(coreActions.newNotification(T.t('r_api_gen_connecttoalms'), '', '', 'topRight', 'error', 0, params.spinnerId, 'set'));
    } else {
        _common.SetLoginLoading(false);
        if (params?.parameters?.inlineNavigation) {
            window.location.href = requestReturn;
        } else {
            window.open(requestReturn, '_blank');
        }
    }
}

function* loginToExamApp(params: any): any {
    let isError = false;
    let errorList: any;
    const _loginService = new LoginService();
    let requestReturn: any;
    yield _loginService.ConnectToExamApp(params.parameters ? params.parameters : null)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        })
        .then(response => {
            if (isError) {
                errorList = response;
            } else {
                requestReturn = response;
            }
        });

    if (isError) {
        yield put(coreActions.newNotification(T.t('r_api_gen_connecttoExamApp'), '', '', 'topRight', 'error', 0, params.spinnerId, 'set'));
    } else {
        if (!requestReturn.startsWith('http:') && !requestReturn.startsWith('https:')) {
            requestReturn = 'https:' + requestReturn;
        }

        window.open(requestReturn);
    }
}

function* loginExternal(params: any): any {

    const _loginService = new LoginService();
    const _common = new Common();

    let AuthInf: IAuthInformation = {
        access_token: null,
        refresh_token: null,
        expire_date: null,
        auth_url: null,
    };
    try{
        const requestReturn = yield _loginService.DecrypTokenAsync(params.token)
        .then((returnData: Response) => {
            return returnData.json();
        }).then((returnData: any) => {
            if (returnData.access_token) {
                const inDate = new Date();

                inDate.setSeconds(inDate.getSeconds() + returnData.expires_in);

                AuthInf = {
                    access_token: returnData.access_token,
                    refresh_token: returnData.refresh_token,
                    expire_date: inDate,
                    auth_url: window.appSettings.AUTH_URL
                };

                _common.InsertAuthLocalStorage(AuthInf);

                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    isLogin: true,
                    isError: false,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };
                return returnValue;

            } else {
                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    isLogin: false,
                    isError: false,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };
                return returnValue;
            }
        }).catch(() => {
            return null;
        });
        if (!requestReturn) {
            yield put(coreActions.newNotification(T.t('r_cant_logging_in') + ' ' + T.t('r_error_internet_connection'), '', '', 'topRight', 'error', undefined, params.spinnerId, 'set'));
        } else if (requestReturn.isError) {
            yield put(coreActions.newNotification(T.t('r_error_logging_in'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
        } else if (!requestReturn.isLogin) {
            yield put(coreActions.newNotification(T.t('r_wrong_username_or_password'), '', null, 'topRight', 'warning', undefined, params.spinnerId, 'set'));
        } else {

            const data = yield put(Action.enrollmentGetAction(''));

            const loginPageService = new LoginPageService();

            const requestIdentityReturn = yield loginPageService.GetUserIdentity(false)
                .then((returnData: Response) => {
                    if (returnData.status === 200) {
                        return returnData.json();
                    } else {
                        return null;
                    }
                }).catch((response) => {
                    _logger.error('requestIdentityReturn -> exception', response.error);
                });

            // Yield user identities information  and login statuss


            if (!requestIdentityReturn) {
                yield put(coreActions.newNotification(T.t('r_error_fetching_user_info'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
            } else {
                yield put(loginActions.resultLoginForm({
                    isLogin: requestReturn.isLogin,
                    isError: requestReturn.isError,
                    errorMessage: requestReturn.errorMessage,
                    customLoginPermission: requestIdentityReturn.customLoginPermission,
                    email: requestIdentityReturn.email,
                    loginPermission: requestIdentityReturn.loginPermission,
                    userName: requestIdentityReturn.userName,
                    userType: requestIdentityReturn.userType,
                    fullName: requestIdentityReturn.fullName,
                    firstName: requestIdentityReturn.firstName,
                    lastName: requestIdentityReturn.lastName,
                    userId: requestIdentityReturn.userId,
                    profileImagePath: requestIdentityReturn.profileImagePath,
                    isSimulate: requestIdentityReturn.isSimulate,
                    culture: requestIdentityReturn.culture,
                    clusterType: requestIdentityReturn.clusterType,
                    organizationId: requestIdentityReturn.organizationId,
                    timeZone: requestIdentityReturn.timeZone,
                    forceChangePassword: requestIdentityReturn.forceChangePassword,
                    programName: requestIdentityReturn.programName
                }, params.spinnerId, 'set'));
                if (params.callback) {
                    yield params.callback(requestReturn.isLogin);

                }
            }
        }
    }catch(error: any){
        _logger.error('login external error', error);
        yield put(coreActions.newNotification(T.t('r_default_error_message'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
    }
    
}

function loginExternalObsToken(returnData: any, AuthInf: any,) {
    const _common = new Common();

    if (returnData.access_token) {
        const inDate = new Date();

        inDate.setSeconds(inDate.getSeconds() + returnData.expires_in);

        AuthInf = {
            access_token: returnData.access_token,
            refresh_token: returnData.refresh_token,
            expire_date: inDate,
            auth_url: window.appSettings.AUTH_URL
        };

        _common.InsertAuthLocalStorage(AuthInf);

        const returnValue: ILoginResultData = {
            errorMessage: returnData.error + ' - ' + returnData.error_description,
            isLogin: true,
            isError: false,
            customLoginPermission: [],
            email: '',
            fullName: '',
            loginPermission: [],
            userName: '',
            userType: 0,
            firstName: '',
            lastName: '',
            userId: '',
            profileImagePath: '',
            culture: 'tr-TR',
            forceChangePassword: false,
            programName: ''
        };

        return returnValue;

    } else {
        const returnValue: ILoginResultData = {
            errorMessage: returnData.error + ' - ' + returnData.error_description,
            customLoginPermission: [],
            email: '',
            fullName: '',
            loginPermission: [],
            userName: '',
            userType: 0,
            isLogin: false,
            isError: false,
            firstName: '',
            lastName: '',
            userId: '',
            profileImagePath: '',
            culture: 'tr-TR',
            forceChangePassword: false,
            programName: ''
        };
        return returnValue;
    }
}

function* loginExternalObs(params: any): any {
    const _loginService = new LoginService();
    const _common = new Common();

    let AuthInf: IAuthInformation = {
        access_token: null,
        refresh_token: null,
        expire_date: null,
        auth_url: null,
    };

    try {
        const response: Response = yield call(_loginService.DecrypTokenObsAsync, params.token);
        const returnData: any = yield response.json();
        yield call(loginExternalObsToken, returnData, AuthInf);

        if (returnData.isError) {
            yield put(coreActions.newNotification(T.t('r_error_logging_in'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
        } else if (!returnData.isLogin) {
            yield put(coreActions.newNotification(T.t('r_wrong_username_or_password'), '', null, 'topRight', 'warning', undefined, params.spinnerId, 'set'));
        } else {
            const loginPageService = new LoginPageService();
            const identityResponse: Response = yield call(loginPageService.GetUserIdentity, false);

            if (identityResponse.status !== 200) {
                yield put(coreActions.newNotification(T.t('r_error_fetching_user_info'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
            } else {
                const identityData: any = yield identityResponse.json();
                yield put(loginActions.resultLoginForm({
                    isLogin: returnData.isLogin,
                    isError: returnData.isError,
                    errorMessage: returnData.errorMessage,
                    customLoginPermission: identityData.customLoginPermission,
                    email: identityData.email,
                    loginPermission: identityData.loginPermission,
                    userName: identityData.userName,
                    userType: identityData.userType,
                    fullName: identityData.fullName,
                    firstName: identityData.firstName,
                    lastName: identityData.lastName,
                    timeZone: identityData.timeZone,
                    userId: identityData.userId,
                    profileImagePath: identityData.profileImagePath,
                    isSimulate: identityData.isSimulate,
                    culture: identityData.culture,
                    clusterType: identityData.clusterType,
                    organizationId: identityData.organizationId,
                    forceChangePassword: identityData.forceChangePassword,
                    programName: identityData.programName
                }, params.spinnerId, 'set'));

                if (params.callback) {
                    yield call(params.callback, returnData.isLogin);
                }
            }
        }
    } catch (error) {
        _logger.error('Error in clickLoginForm', JSON.stringify(error));
        yield put(coreActions.newNotification(T.t('r_cant_logging_in') + ' ' + T.t('r_error_internet_connection'), '', '', 'topRight', 'error', undefined, params.spinnerId, 'set'));
    }
}

function* loginEdevlet(params: any): any {

    const _loginService = new LoginService();
    const _common = new Common();

    let AuthInf: IAuthInformation = {
        access_token: null,
        refresh_token: null,
        expire_date: null,
        auth_url: null,
    };

    const requestReturn = yield _loginService.DecrypEdevletTokenAsync(params.token)
        .then((returnData: Response) => {
            return returnData.json();
        }).then((returnData: any) => {
            if (returnData.access_token) {
                const inDate = new Date();

                inDate.setSeconds(inDate.getSeconds() + returnData.expires_in);

                AuthInf = {
                    access_token: returnData.access_token,
                    refresh_token: returnData.refresh_token,
                    expire_date: inDate,
                    auth_url: window.appSettings.AUTH_URL
                };

                _common.InsertAuthLocalStorage(AuthInf);

                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    isLogin: true,
                    isError: false,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };
                return returnValue;

            } else {
                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    isLogin: false,
                    isError: false,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };
                return returnValue;
            }
        }).catch((error) => {
            _logger.error('Error in externalLogin', JSON.stringify(error));
            return null;
        });
    if (!requestReturn) {
        yield put(coreActions.newNotification(T.t('r_cant_logging_in') + ' ' + T.t('r_error_internet_connection'), '', '', 'topRight', 'error', undefined, params.spinnerId, 'set'));
    } else if (requestReturn.isError) {
        yield put(coreActions.newNotification(T.t('r_error_logging_in'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
    } else if (!requestReturn.isLogin) {
        yield put(coreActions.newNotification(T.t('r_wrong_username_or_password'), '', null, 'topRight', 'warning', undefined, params.spinnerId, 'set'));
    } else {

        const data = yield put(Action.enrollmentGetAction(''));

        const loginPageService = new LoginPageService();

        const requestIdentityReturn = yield loginPageService.GetUserIdentity(false)
            .then((returnData: Response) => {
                if (returnData.status === 200) {
                    return returnData.json();
                } else {
                    return null;
                }
            }).catch((response) => {
                _logger.error('requestIdentityReturn -> exception', response.error);
            });

        // Yield user identities information  and login statuss


        if (!requestIdentityReturn) {
            yield put(coreActions.newNotification(T.t('r_error_fetching_user_info'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
        } else {
            yield put(coreActions.newNotification(T.t('r_welcome') + ' ' + requestIdentityReturn.fullName + '!', '', null, 'topRight', 'success', undefined, params.spinnerId, 'set'));

            yield put(loginActions.resultLoginForm({
                isLogin: requestReturn.isLogin,
                isError: requestReturn.isError,
                errorMessage: requestReturn.errorMessage,
                customLoginPermission: requestIdentityReturn.customLoginPermission,
                email: requestIdentityReturn.email,
                loginPermission: requestIdentityReturn.loginPermission,
                userName: requestIdentityReturn.userName,
                userType: requestIdentityReturn.userType,
                fullName: requestIdentityReturn.fullName,
                firstName: requestIdentityReturn.firstName,
                lastName: requestIdentityReturn.lastName,
                userId: requestIdentityReturn.userId,
                profileImagePath: requestIdentityReturn.profileImagePath,
                isSimulate: requestIdentityReturn.isSimulate,
                culture: requestIdentityReturn.culture,
                clusterType: requestIdentityReturn.clusterType,
                organizationId: requestIdentityReturn.organizationId,
                timeZone: requestIdentityReturn.timeZone,
                forceChangePassword: requestIdentityReturn.forceChangePassword,
                programName: requestIdentityReturn.programName
            }, params.spinnerId, 'set'));
        }
    }
}

// User Login and get user identities information

function* whenUserLoginIsSuccess(requestIdentityReturn: any, params: any, requestReturn: any, common: any) {
    if (params.loginCulture) {
        yield put(profileActions.getChangeLanguageAction(params.loginCulture));
    }
    if (requestIdentityReturn.userType === UserType.Admin) {
        common.SetLoginLoading(true);
        if (requestIdentityReturn.userName.startsWith('ADVANCITY')) {
            yield put(loginActions.connectToAlms("connectToAlms", "get", { inlineNavigation: true, userName: params.params.userName, password: params.params.password }))

        } else {
            yield put(loginActions.connectToAlms("connectToAlms", "get", { inlineNavigation: true }))

        }
    }
    yield put(loginActions.resultLoginForm({
        isLogin: requestReturn.isLogin,
        isError: requestReturn.isError,
        errorMessage: requestReturn.errorMessage,
        customLoginPermission: requestIdentityReturn.customLoginPermission,
        email: requestIdentityReturn.email,
        loginPermission: requestIdentityReturn.loginPermission,
        userName: requestIdentityReturn.userName,
        userType: requestIdentityReturn.userType,
        fullName: requestIdentityReturn.fullName,
        firstName: requestIdentityReturn.firstName,
        lastName: requestIdentityReturn.lastName,
        userId: requestIdentityReturn.userId,
        profileImagePath: requestIdentityReturn.profileImagePath,
        isSimulate: requestIdentityReturn.isSimulate,
        culture: requestIdentityReturn.culture,
        clusterType: requestIdentityReturn.clusterType,
        organizationId: requestIdentityReturn.organizationId,
        timeZone: requestIdentityReturn.timeZone,
        forceChangePassword: requestIdentityReturn.forceChangePassword,
        programName: requestIdentityReturn.programName
    }, params.spinnerId, 'set'));
    if (requestIdentityReturn.userType !== UserType.Admin) {
        yield put(coreActions.newNotification(T.t('r_welcome') + ' ' + requestIdentityReturn.fullName + '!', '', null, 'topRight', 'success', undefined, params.spinnerId, 'set'));

    }
}

function* clickLoginForm(params: any): any {

    const _loginService = new LoginService();
    const _common = new Common();

    let AuthInf: IAuthInformation = {
        access_token: null,
        refresh_token: null,
        expire_date: null,
        auth_url: null,
    };

    // Kullanıcı adı boş kontrolü
    if (!params.params.userName) {
        yield put(coreActions.newNotification(T.t('r_username_empty'), '', null, 'topRight', 'warning', undefined, params.spinnerId, 'set'));
        return;
    }

    const requestReturn = yield _loginService.RequestAccessTokenAsync(params.params.userName, params.params.password, params.googleCaptchaToken)
        .then((returnData: Response) => {
            return returnData.json();
        }).then((returnData: any) => {
            if (returnData.access_token) {
                const inDate = new Date();

                inDate.setSeconds(inDate.getSeconds() + returnData.expires_in);

                AuthInf = {
                    access_token: returnData.access_token,
                    refresh_token: returnData.refresh_token,
                    expire_date: inDate,
                    auth_url: window.appSettings.AUTH_URL
                };

                _common.InsertAuthLocalStorage(AuthInf);

                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    isLogin: true,
                    isError: false,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };

                return returnValue;

            } else {
                const returnValue: ILoginResultData = {
                    errorMessage: returnData.error + ' - ' + returnData.error_description,
                    customLoginPermission: [],
                    email: '',
                    fullName: '',
                    loginPermission: [],
                    userName: '',
                    userType: 0,
                    isLogin: false,
                    isError: false,
                    firstName: '',
                    lastName: '',
                    userId: '',
                    profileImagePath: '',
                    culture: 'tr-TR',
                    forceChangePassword: false,
                    programName: ''
                };
                return returnValue;
            }
        }).catch((error) => {
            _logger.error('Error in clickLoginForm', JSON.stringify(error));
            return null;
        });

    if (!requestReturn) {
        yield put(coreActions.newNotification(T.t('r_cant_logging_in') + ' ' + T.t('r_error_internet_connection'), '', '', 'topRight', 'error', undefined, params.spinnerId, 'set'));
    } else if (requestReturn.isError) {
        yield put(coreActions.newNotification(T.t('r_error_logging_in'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
    } else if (!requestReturn.isLogin) {
        yield put(coreActions.newNotification(T.t('r_wrong_username_or_password'), '', null, 'topRight', 'warning', undefined, params.spinnerId, 'set'));
    } else {

        const data = yield put(Action.enrollmentGetAction(''));

        const loginPageService = new LoginPageService();

        const requestIdentityReturn = yield loginPageService.GetUserIdentity(false)
            .then((returnData: Response) => {
                if (returnData.status === 200) {
                    return returnData.json();
                } else {
                    return null;
                }
            }).catch((response) => {
                _logger.error('requestIdentityReturn -> exception', response.error);
            });

        // Yield user identities information  and login statuss
        if (!requestIdentityReturn) {
            yield put(coreActions.newNotification(T.t('r_error_fetching_user_info'), '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
        } else {
            yield whenUserLoginIsSuccess(requestIdentityReturn, params, requestReturn, _common);
        }
    }
}

function* setMyForgotPassword(params: any): any {
    yield put(loginActions.myForgotPasswordSetAction({ haveUser: null, isQuestion: null, passwordSecurtiyQuestion: null, userName: '' }, 'ResetPassword'));
    const _loginService = new LoginService();
    let pageType: string = 'ResetPassword';
    let isError: boolean = false;
    try {
        const requestReturn = yield _loginService.MyForgotPasswordCheckUser(params.searchedUser)
            .then((returnData: Response) => {
                if (returnData.status !== 200) {
                    isError = true;
                } else {
                    return returnData.json();
                }
            }).then((returnData: any) => {
                return returnData;
            }).catch((response) => {
                isError = true;
            });
        if (isError) {
            yield put(coreActions.newNotification(T.t('r_my_forgot_check_user_error_api_message'), '', '', 'topRight', 'error'));
            yield put(loginActions.myForgotPasswordSetAction({ haveUser: null, isQuestion: null, passwordSecurtiyQuestion: null, userName: null }, 'ResetPassword'));
        } else {

            if (requestReturn && !requestReturn.haveUser) {
                pageType = 'ResetPassword';
                yield put(coreActions.newNotification(T.t('r_my_forgot_check_user_error_message'), '', '', 'topRight', 'warning'));
                yield put(loginActions.myForgotPasswordSetAction(requestReturn, pageType, params.spinnerId, 'set'));
            } else {
                if (requestReturn.isQuestion === 'true' || requestReturn.isQuestion === 'True' || requestReturn.isQuestion === true) {
                    pageType = 'MyForgotPasswordQuestion';
                } else {
                    pageType = 'Login';
                    yield put(coreActions.newNotification(T.t('r_my_forgot_password_send_mail_success_message'), '', '', 'topRight', 'success'));

                }
                yield put(loginActions.myForgotPasswordSetAction(requestReturn, pageType, params.spinnerId, 'set'));
            }
        }

    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_my_forgot_check_user_error_api_message'), '', '', 'topRight', 'error'));
        yield put(loginActions.myForgotPasswordSetAction({ haveUser: null, isQuestion: null, passwordSecurtiyQuestion: null, userName: null }, 'ResetPassword', params.spinnerId, 'set'));
    }

}

function* setMyForgotPasswordQuestionsAnswer(params: any): any {
    yield put(loginActions.myForgotPasswordQuestionAnswerSetAction(false));
    const _loginService = new LoginService();
    let isError: boolean = false;
    try {
        const requestReturn = yield _loginService.MyForgotPasswordQuestionAnswer(params.searchedUser, params.typedText)
            .then((returnData: Response) => {
                if (returnData.status !== 200) {
                    isError = true;
                } else {
                    return returnData.json();
                }
            }).then((returnData: any) => {
                return returnData;
            }).catch((response) => {
                isError = true;

            });
        if (isError) {
            yield put(coreActions.newNotification(T.t('r_my_forgot_password_question_answer_api_error_message'), '', '', 'topRight', 'error'));
        } else {
            if (requestReturn !== true) {
                yield put(coreActions.newNotification(T.t('r_my_forgot_password_question_answer_error_message'), '', '', 'topRight', 'warning'));
            }
        }

        yield put(loginActions.myForgotPasswordQuestionAnswerSetAction(requestReturn, params.spinnerId, 'set'));
    } catch (error: any) {
        _logger.error('Error in setMyForgotPasswordQuestionsAnswer', error);
        yield put(coreActions.newNotification(T.t('r_my_forgot_password_question_answer_error_message'), '', '', 'topRight', 'error'));
        yield put(loginActions.myForgotPasswordQuestionAnswerSetAction(false, params.spinnerId, 'set'));
    }

}

function* setNewPasswordCheckToken(params: any): any {
    yield put(loginActions.myForgotPasswordCheckTokenSetAction('NewPassword', false, false, false, 0, 0, ''));
    const _loginService = new LoginService();
    let isError: boolean = false;
    let currentPage: string = '';
    try {
        const requestReturn = yield _loginService.MyForgotPasswordCheckToken(params.token)
            .then((returnData: Response) => {
                if (returnData.status !== 200) {
                    isError = true;
                } else {
                    return returnData.json();
                }
            }).then((returnData: any) => {
                return returnData;
            }).catch((response) => {
                isError = true;

            });
        if (isError) {
            yield put(coreActions.newNotification(T.t('r_error_verifying_password_reset_code'), '', '', 'topRight', 'error'));
        } else {
            if (requestReturn && requestReturn.notFound === true) {
                currentPage = 'Login';
                yield put(coreActions.newNotification(T.t('r_password_reset_code_not_verified'), '', '', 'topRight', 'error'));
                window.history.pushState(null, '', window.appSettings.DEFAULT_URL);
            } else if (requestReturn && requestReturn.expired === true) {
                currentPage = 'Login';
                yield put(coreActions.newNotification(T.t('r_password_reset_code_expired'), '', '', 'topRight', 'warning'));
                window.history.pushState(null, '', window.appSettings.DEFAULT_URL);
            } else {
                currentPage = 'NewPassword';
            }
        }

        yield put(loginActions.myForgotPasswordCheckTokenSetAction(
            currentPage,
            requestReturn.expired,
            true,
            requestReturn.notFound,
            requestReturn.alphaNumericLength,
            requestReturn.minPasswordLength,
            requestReturn.passwordStrength));
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_error_verifying_password_reset_code'), '', '', 'topRight', 'error'));
        _logger.error('Error in setNewPasswordCheckToken', error);
        yield put(loginActions.myForgotPasswordCheckTokenSetAction(currentPage, false, true, false, 0, 0, ''));
    }

}


function* setNewPasswordSave(params: any): any {
    yield put(loginActions.myForgotPasswordSaveSetAction(false));
    const _loginService = new LoginService();
    let isError: boolean = false;
    try {
        yield _loginService.MyForgotPasswordSave(params.token, params.password)
            .then((returnData: Response) => {
                if (returnData.status !== 200) isError = true;
                else return returnData.json();
            }).then((returnData: any) => returnData).catch((response) => { isError = true; });
        if (isError) {
            yield put(coreActions.newNotification(T.t('r_my_forgot_password_error_message'), '', '', 'topRight', 'error'));
        } else {
            yield put(coreActions.newNotification(T.t('r_my_forgot_password_save_new_password_success_message'), '', '', 'topRight', 'success'));
            yield put(loginActions.setCurrentPage('Login', ''));
            window.history.pushState(null, '', window.appSettings.DEFAULT_URL);
        }
        yield put(loginActions.myForgotPasswordSaveSetAction(!isError, params.spinnerId, 'set'));
    } catch (error: any) {
        _logger.error('Error in setNewPasswordSave', error);
        yield put(coreActions.newNotification(T.t('r_my_forgot_password_error_message'), '', '', 'topRight', 'error'));
        yield put(loginActions.myForgotPasswordSaveSetAction(false, params.spinnerId, 'set'));
    }
}


function* getUserIdentity(): any {
    let isError: boolean = false;
    let errorMessage: string = '';
    const loginPageService = new LoginPageService();
    const requestReturn = yield loginPageService.GetUserIdentity(true)
        .then((returnData: Response) => {
            if (returnData.status === 200) {
                return returnData.json();
            } else {
                return null;
            }
        }).then((returnData: any) => {
            if (returnData !== undefined) {
                return returnData;

            } else {
                isError = true;
                errorMessage = returnData.error + ' - ' + returnData.error_description;
            }
        }).catch((response) => {
            errorMessage = response.error;
            isError = true;
            _logger.error('Error in getUserIdentity', response);
        });

    if (isError) {
        yield put(coreActions.newNotification(errorMessage));
    } else {
        yield put(loginActions.setUserIdentitiy(requestReturn));
    }
}

function* logOutFromAlms(params?: any): any {
    let isError = false;
    let errorList: any;

    const requestOptions = {
        method: 'GET',
        headers: {
            Accept: '*/*',
        }
    };
    try {
        fetch(window.location.origin + '/Account/DeleteSessionCookies', requestOptions)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (params.callback) {
                    params.callback();
                }
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_logout_error_message'), 'topRight');
    }

}

function* checkVerificationCode(params: any): any {
    let isError: boolean = false;
    let errorList: any;
    const loginService = new LoginService();
    yield loginService.CheckVerificationCode(params.username, params.verificationCode)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
                return responseData.json();
            }
            return responseData
        }).then((response: any) => {
            if (isError)
                errorList = response;
        });

    if (isError) {
        if (errorList) {
            if (!params.isForLogin) {
                yield put(SetTwoFactorMethodError(T.t("r_send_check_two_factor_verification_code_error")))
            } else {
                let errorMessage = Object.keys(errorList).map((key: any) => T.t(errorList[key])).join(' ');
                yield put(SetTwoFactorMethodError(errorMessage))
            }
        } else {
            Notification.setNotification('error', T.t('r_send_check_two_factor_verification_code_error'), 'topRight');
        }

    } else if (params.callback) {
        Notification.setNotification('success', T.t("r_gen_success"), 'topRight');
        params.callback();
    }
}

function* VerificateUser(params: any): any {
    let isError: boolean = false;
    let errorList: any;
    const loginService = new LoginService();
    try{
        const requestReturn = yield loginService.VerificateUser(params.username, params.token)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
                errorList = responseData;
            }
            return responseData.json();
        });

    if (isError) {
        errorList ?
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_send_two_factor_verification_mail_error'), 'topRight');
    } else if (params.callback) {
        if (requestReturn !== null && requestReturn.length > 0) {
            yield put(SetVerificateUserMail(requestReturn, "SetVerificateUserMail", "set"))
            window.location.href = window.appSettings.DEFAULT_URL + "/verification"
        } else {
            params.callback();
        }
    }
    }catch(error: any){
        _logger.error('Error in verificateUser', JSON.stringify(error));
        yield put(coreActions.newNotification(T.t('r_default_error_message') , '', null, 'topRight', 'error', undefined, params.spinnerId, 'set'));
    }
    
}

// Our watcher Saga: spawn a new incrementAsync task on each INCREMENT_ASYNC
export function* watchGetLoginPageData() {

    yield takeLatest(constants.loginActions.LOGIN_GETPAGEDATA, setLoginPageData);
}

export function* watchClickLoginForm() {

    yield takeEvery(constants.loginActions.LOGIN_CLICKLOGINFORM, clickLoginForm);
}
export function* watchMyForgotPassword() {

    yield takeEvery(constants.loginActions.LOGIN_MY_FORGOT_PASSWORD_GET, setMyForgotPassword);
}

export function* watchMyForgotPasswordQuestionAnswer() {

    yield takeEvery(constants.loginActions.LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_GET, setMyForgotPasswordQuestionsAnswer);
}

export function* watchMyForgotCheckToken() {
    yield takeEvery(constants.loginActions.LOGIN_RESET_PASSWORD_CHECK_TOKEN_GET, setNewPasswordCheckToken);
}

export function* watchMyForgotSave() {
    yield takeEvery(constants.loginActions.LOGIN_RESET_PASSWORD_SAVE_GET, setNewPasswordSave);
}

export function* watchgetUserIdentity() {
    yield takeEvery(constants.loginActions.LOGIN_GETUSERIDENTITY, getUserIdentity);
}

export function* watchLoginExternal() {
    yield takeEvery(constants.loginActions.LOGIN_EXTERNALLOGIN, loginExternal);
}

export function* watchLoginExternalObs() {
    yield takeEvery(constants.loginActions.LOGIN_EXTERNALLOGINOBS, loginExternalObs);
}

export function* watchLoginEdevlet() {
    yield takeEvery(constants.loginActions.LOGIN_EDEVLETLOGIN, loginEdevlet);
}

export function* watchLoginToAlms() {
    yield takeEvery(constants.loginActions.LOGIN_TOALMS, loginToAlms);
}

export function* watchLoginToExamApp() {
    yield takeEvery(constants.loginActions.LOGIN_TOEXAMAPP, loginToExamApp);
}
export function* watchLogOutFromAlms() {
    yield takeEvery(constants.loginActions.ALMS_LOGIN_LOGOUT, logOutFromAlms);
}

export function* wathCheckVerificationCode() {
    yield takeEvery(constants.loginActions.CHECK_VERIFICATION_CODE, checkVerificationCode);
}

export function* watchVerificateUser() {
    yield takeLatest(constants.loginActions.VERIFICATE_USER, VerificateUser);
}

export default function* loginSagas() {
    yield all([
        watchGetLoginPageData(),
        watchClickLoginForm(),
        watchMyForgotPassword(),
        watchMyForgotPasswordQuestionAnswer(),
        watchMyForgotCheckToken(),
        watchMyForgotSave(),
        watchgetUserIdentity(),
        watchLoginExternal(),
        watchLoginExternalObs(),
        watchLoginEdevlet(),
        watchLoginToAlms(),
        watchLoginToExamApp(),
        wathCheckVerificationCode(),
        watchVerificateUser()
    ]);
}
